import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import CardBox from "@material-ui/core/Card";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from "@material-ui/core/FormHelperText";
import Logo from '../../assets/logo.svg';
//import bgImg from '../../assets/scmBgImg.png';
import TeamsLogo from '../../assets/teams.png';
import {
    AzureAD,
    authenticationState,
    authenticatedFunction,
    logout,
} from "react-aad-msal";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
} from "@azure/msal-react";
import { AuthProvider, msalConfig } from "../Authentication";


const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(5),
    },
    field: {
        marginLeft: '20px',
        marginRight: '15px',
        width: 325,
    },
}));

export default function Login(props) {
    const { handleSubmit, register, control, errors } = useForm([]);
    const [password, setPassword] = React.useState(true);
    const classes = useStyles();
    const { instance, accounts } = useMsal();
    const onSubmit = (data) => {
    };

    const loginMS = (data) => {
        instance.loginRedirect(msalConfig).catch((e) => {
        });
    }

    return (
        <div class="flexCont">
            <div class="d-flex flex-column flex-root">
                <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white">
                    <div class="content d-flex flex-column w-100 login-bg SCM-bg">
                        <img src={Logo} width='80' height='80' />
                        <div class="login-aside d-flex flex-row-auto ">
                            <div class="d-flex flex-column-fluid flex-column loginform">
                                <div class="d-flex flex-column-fluid flex-column flex-center">

                                    <div class="loginTitle">
                                        <h1>Welcome to <span>CHAIL</span></h1>
                                        <h2></h2>
                                        <p>Login with Business Account:</p>
                                        <Button color="primary" fullWidth onClick={() => loginMS()} variant="contained" >
                                            Let me in
                                        </Button>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};